import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "greenpoint"
}
const _hoisted_4 = {
  key: 1,
  class: "redpoint"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "vue-router";
import { computed, defineComponent } from "vue";
import { ref, reactive, toRaw } from "vue";
import type { TableProps } from "ant-design-vue";
import { message } from "ant-design-vue";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getLanguage } from "@/common/translate";
import { operateLogs } from "@/common/logs";

export default /*@__PURE__*/_defineComponent({
  __name: 'SoftwareMonitoring',
  setup(__props) {

const loading = ref(false);
/**操作日志记录 */
operateLogs('Access sensor management');
/**操作日志记录 */
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang();
const modalState = reactive({
  visible: false,
  title: getLanguage("配置"),
  confirmLoading: false,
});
const formState = ref({
  factoryId: '',
  keyword: "",
  enable: "-1",
  skip: 1,
  take: 10,
});

// 新增
const add = () => {
  modalState.title = getLanguage("新增");
  modalForm.value = {
    enable: true,
    factoryId: "",
    id: 0,
    nickName: "",
    userName: "",
    password: ''
  };
  modalState.visible = true;
};

const pagination = computed(() => ({
  total: 0,
  current: formState.value.skip,
  pageSize: formState.value.take,
}));
const deleteThis = (val: any) => {
  const config = {
    params: { key: val.key },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.delete("/api/external/service/status", config).then((res) => {
    if (res) {
      message.success(getLanguage("操作成功"));
      search();
    } else {
    }
  });
};
let dataSource = ref([]);
const columns = [
  {
    title: getLanguage("服务名称"),
    dataIndex: "name",
    align: "center"
  },
  {
    title: getLanguage("服务描述"),
    dataIndex: "remark",
    align: "center"
  },
  {
    title: getLanguage("服务器ip"),
    dataIndex: "ip",
    align: "center"
  },
  {
    title: getLanguage("服务器端口号"),
    dataIndex: "port",
    align: "center"
  },
  {
    title: getLanguage("最后在线时间"),
    dataIndex: "date",
    align: "center"
  },
  {
    title: getLanguage("当前是否在线"),
    dataIndex: "online",
    align: "center"
  },
  {
    title: getLanguage("操作"),
    dataIndex: "act",
    align: "center"
  }
];

let modalForm = ref<any>({
  enable: true,
  factoryId: "",
  id: 0,
  nickName: "",
  userName: "",
});
const formStateRef = ref<any>();
const roleSetting = async (val: any) => {
  modalState.title = "配置";
  const config = {
    params: { id: val.config_id },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result2 = await request.get("/api/dt/das/info", config);
  modalForm.value = reactive(JSON.parse(JSON.stringify(result2.data)));
  modalState.visible = true;
  setTimeout(() => {
    formStateRef.value.clearValidate();
  }, 500);
};
const clearValidate = (name: any) => {
  formStateRef.value.clearValidate(name);
};

// 查询
const search = () => {
  const config = {
    params: formState.value,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/external/service/status", config).then((res) => {
    if (res) {
      dataSource.value = res.data;
    }
  });
};

search();
const roleList = ref<any>();
// 查询
const getRole = () => {
  const config = {
    params: { keyword: "" },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/roles", config).then((res: any) => {
    if (res) {
      roleList.value = res.data.list;
    }
  });
};
getRole();
let factoryList = ref<any>()
const loadFactory = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {

      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory"
      }));
      // let factory = [];
      // for (var i = 0; i < list.length; i++) {
      //   var element = list[i];
      //   if (!element.parentId) {
      //     element.children = list.filter((t: any) => t.parentId == element.id);
      //     factory.push(element);
      //   }
      // }
      factoryList.value = list;
    }
  });
};
loadFactory()

return (_ctx: any,_cache: any) => {
  const _component_delete_outlined = _resolveComponent("delete-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(language) === 'English' ? _unref(enUS) : _unref(zhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_layout_content, { style: {"padding":"0 20px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_table, {
                bordered: "",
                emptyText: '暂无数据',
                columns: columns,
                "data-source": _unref(dataSource),
                pagination: false,
                loading: loading.value,
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'online')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        (text == '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
                        (text == '1')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getLanguage)('在线')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(getLanguage)('断线')), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 1,
                        title: _unref(getLanguage)('确定删除此条数据'),
                        onConfirm: ($event: any) => (deleteThis(record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_delete_outlined),
                              _createTextVNode(_toDisplayString(_unref(getLanguage)('删除')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["title", "onConfirm"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "loading"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})